module.exports = __webpack_public_path__ + "static/cosyzebra2-3e8e91b212f99a79adc8f5a1eebf94b9.png";